'use strict';

angular.module('internal.users')
    .controller('InternalUserBackgroundChecks', ['$scope', 'BackgroundChecks', '$stateParams', function ($scope, BackgroundChecks, $stateParams) {
        $scope.loading = true;

        BackgroundChecks.getByUserID({ user_id: $stateParams.id }).then(function (data) {
            $scope.backgroundCheckHistory = data;
            $scope.loading = false;
        });

    }])
;